import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CancelCampaignService {
cancel = false
  constructor() { }

  closeCancelModal() {
    this.cancel = false
  }

  openCancelModal() {
    this.cancel = true
  }
}
